import './App.css';
import React, { useState, useEffect } from 'react';
import data from './data/coutries.json'
import FormGroup from './Components/FormGroup/FormGroup';
import BudgetYourTripB from './Components/BudgetYourTrip/BudgetYourTripB';

const App = () => {

    const selectLabels = Object.values(data);

    const [country, setCountry] = useState('');
    const [lodgingDefault, setLodgingDefault] = useState(0);
    const [foodBeverageDefault, setFoodBeverageDefault] = useState(0);
    const [localTransDefault, setLocalTransDefault] = useState(0);
    const [entertainmentDefault, setEntertainmentDefault] = useState(0);
    const [tipsDefault, setTipsDefault] = useState(0);

    const [transferData, setTransferData] = useState({
        thankYouPage: '',
        formAbuse: false,
        maxSubMsg: '',
        ajaxNonce: '',
    });

    useEffect(() => {
        const data = window.tbc_vars;

        if (data) {
            setTransferData(prevState => ({
                ...prevState,
                thankYouPage: data.tp,
                maxSubMsg: data.mm,
                ajaxNonce: data.ajaxNonce,
            }));

            // Dynamic check to bypass server cache
            const checkStatus = async () => {
                try {
                    const response = await fetch(`/wp-admin/admin-ajax.php?action=check_status&_=${Date.now()}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                    });
                    const result = await response.json();
                    if (result.success) {
                        setTransferData(prevState => ({
                            ...prevState,
                            formAbuse: !result.data.canSubmit,
                        }));
                    }
                } catch (error) {
                    console.error('Status check failed:', error);
                }
            };
            checkStatus();
        } else {
            console.error('Invalid or missing tbc_vars');
        }
    }, []);

    const [countrySelected, setCountrySelected] = useState(false);
    const handleCountryChange = (newValue) => {
        if (newValue !== 'Select a country') {
            setCountry(newValue);
            setCountrySelected(true);
        } else {
            setCountry('');
            setCountrySelected(false);
        }
    }

    // Slush Fund set to 10% by default
    const slushDefault = 10;

    const handleLoadedWidget = (newValue) => {
        const widgetCheckLoadedElem = document.querySelector('.budgetyourtrip-widget-container');
        if (widgetCheckLoadedElem) {
            // Now that the Widget is loaded grab those values from the dom
            let newLodgingValue = 0;
            let newFoodValue = 0;
            let newBeverageValue = 0;
            let newWaterValue = 0;
            let newFoodBeverageValue = newFoodValue + newBeverageValue + newWaterValue;
            let newTransportationValue = 0;
            let newEntertaimentValue = 0;
            let newTipsValue = 0;

            // Access the HTML element and do something with it
            const widgetElement = document.getElementById("widget-container");
            const htmlLodging = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-1 .budgetyourtrip-curvalue')
            if (htmlLodging && htmlLodging.innerHTML) {
                newLodgingValue = Math.ceil(parseInt(htmlLodging.innerHTML))
            }
            const htmlFood = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-food .budgetyourtrip-curvalue');
            const htmlBeverage = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-alcohol .budgetyourtrip-curvalue');
            const htmlWater = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-water .budgetyourtrip-curvalue');
            if (htmlFood && htmlFood.innerHTML) {
                newFoodValue = Math.ceil(parseInt(htmlFood.innerHTML));
            }
            if (htmlBeverage && htmlBeverage.innerHTML) {
                newBeverageValue = Math.ceil(parseInt(htmlBeverage.innerHTML));
            }
            if (htmlWater && htmlWater.innerHTML) {
                newWaterValue = Math.ceil(parseInt(htmlWater.innerHTML));
            }
            newFoodBeverageValue = newFoodValue + newBeverageValue + newWaterValue;

            const htmlLocalTrans = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-local-transportation .budgetyourtrip-curvalue')
            if (htmlLocalTrans && htmlLocalTrans.innerHTML) {
                newTransportationValue = Math.ceil(parseInt(htmlLocalTrans.innerHTML))
            }
            const htmlEntertaiment = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-entertainment .budgetyourtrip-curvalue')
            if (htmlEntertaiment && htmlEntertaiment.innerHTML) {
                newEntertaimentValue = Math.ceil(parseInt(htmlEntertaiment.innerHTML))
            }
            const htmlTips = widgetElement.querySelector('.budgetyourtrip-cost-tile-category-tips-and-handouts .budgetyourtrip-curvalue')
            if (htmlTips && htmlTips.innerHTML) {
                newTipsValue = parseInt(Math.ceil(htmlTips.innerHTML));
            }

            // Set Default Values
            setLodgingDefault(newLodgingValue);
            setFoodBeverageDefault(newFoodBeverageValue);
            setLocalTransDefault(newTransportationValue);
            setEntertainmentDefault(newEntertaimentValue);
            setTipsDefault(newTipsValue)

        }
    }

    return (
        <div className="budget-calculator-container">
            <BudgetYourTripB
                selectLabels={selectLabels}
                onCountryChange={handleCountryChange}
                onWidgetLoaded={handleLoadedWidget}
            />
            <FormGroup
                countrySelected={countrySelected}
                country={country}
                lodgingDefault={lodgingDefault}
                foodBeverageDefault={foodBeverageDefault}
                localTransDefault={localTransDefault}
                entertainmentDefault={entertainmentDefault}
                tipsDefault={tipsDefault}
                slushDefault={slushDefault}
                transferData={transferData}
            />
        </div>
    );
};

export default App;
